<template>
    <div class="colors_page">
        <div class="container">
            <Breadcrumb :breadcrumbs="breadcrumbs"></Breadcrumb>
            <section class="colors-swatches-section">
                <div class="main-section row">
                    <div class="left-panel col-md-2">
                        <div id="accordion">
                            <div class="card">
                                <div class="card-header" id="headingOne">
                                    <h5 class="mb-0">
                                        <button
                                            class="btn btn-link collapsed"
                                            data-toggle="collapse"
                                            data-target="#collapseOne"
                                            aria-expanded="true"
                                            aria-controls="collapseOne"
                                        >
                                            <ul>
                                                <li class="main">
                                                    Standard
                                                    {{
                                                        camelCase(
                                                            colorsConfig.colors_type
                                                        )
                                                    }}
                                                </li>
                                            </ul>
                                        </button>
                                    </h5>
                                </div>

                                <ul>
                                    <li class="all">
                                        <ul>
                                            <li>
                                                <a
                                                    :class="{
                                                        'all-color pl-0':
                                                            colorsConfig.colors_shade ==
                                                            'All'
                                                    }"
                                                    href="#"
                                                    @click="
                                                        filterColorShade('All')
                                                    "
                                                >
                                                    All Colors
                                                </a>
                                            </li>
                                            <li
                                                v-for="(
                                                    shades, index
                                                ) of colors_shades"
                                                :key="index"
                                            >
                                                <a
                                                    href="javascript:void(0);"
                                                    :class="{
                                                        'all-color pl-0':
                                                            colorsConfig.colors_shade ==
                                                            shades
                                                    }"
                                                    @click="
                                                        filterColorShade(shades)
                                                    "
                                                    >{{ shades }}</a
                                                >
                                                <span
                                                    >({{
                                                        colorShadeCount(shades)
                                                    }})</span
                                                >
                                            </li>
                                        </ul>
                                    </li>
                                </ul>
                                <!-- </div>
                                </div> -->
                            </div>
                        </div>
                    </div>
                    <div class="col-md-10 right_panel">
                        <ul class="nav nav-tabs colors-tabs">
                            <li
                                :class="{ active: active_tab == 'ink' }"
                                @click="activateTab('ink')"
                            >
                                <a href="javascript:void(0);" data-toggle="tab"
                                    >Ink Colors Swatch</a
                                >
                            </li>
                            <li
                                :class="{ active: active_tab == 'thread' }"
                                @click="activateTab('thread')"
                            >
                                <a href="javascript:void(0);" data-toggle="tab"
                                    >Thread Colors Swatch</a
                                >
                            </li>
                            <li
                                :class="{ active: active_tab == 'vinyl' }"
                                @click="activateTab('vinyl')"
                            >
                                <a href="javascript:void(0);" data-toggle="tab"
                                    >Vinyl Colors</a
                                >
                            </li>
                            <li
                                :class="{ active: active_tab == 'fabric' }"
                                @click="activateTab('fabric')"
                            >
                                <a href="javascript:void(0);" data-toggle="tab"
                                    >Fabric Colors</a
                                >
                            </li>
                        </ul>
                        <div class="right-panel">
                            <div class="tab-content">
                                <div
                                    id="home"
                                    class="tab-pane fade colors-panel"
                                    :class="{
                                        'active show': active_tab == 'ink'
                                    }"
                                >
                                    <div class="pane-body">
                                        <h3>
                                            Screen Print - Standard Ink Colors
                                        </h3>
                                        <p>
                                            Choose from these standard ink
                                            colors for printing on apparel.
                                            Don’t see a specific color you’re
                                            looking for? For a $25 ink-mix fee,
                                            we can match your Pantone color or
                                            hex codes. Hex codes may not be as
                                            accurate. We recommend using a
                                            Pantone color if requiring an ink
                                            match.
                                        </p>
                                        <small v-if="all_colors.length == 0"
                                            >No colors found.</small
                                        >
                                        <div class="color-boxes row">
                                            <div
                                                v-for="(
                                                    color, index
                                                ) in all_colors"
                                                class="color-box col-md-2 col-lg-2 col-sm-6"
                                                :key="index"
                                            >
                                                <div
                                                    v-if="color.hex"
                                                    class="color"
                                                    :style="
                                                        'background-color: ' +
                                                        color.hex
                                                    "
                                                >
                                                    <span>{{
                                                        color.name
                                                    }}</span>
                                                </div>
                                                <div
                                                    v-else-if="color.swatches"
                                                    class="color"
                                                    :style="
                                                        'background-image:url(' +
                                                        color.swatches +
                                                        ');background-repeat: no-repeat;background-size: 100% 100%;'
                                                    "
                                                >
                                                    <span>{{
                                                        color.name
                                                    }}</span>
                                                </div>
                                                <p>{{ color.hex }}</p>
                                                <p>{{ color.pms }}</p>
                                                <p>{{ color.name }}</p>
                                            </div>
                                        </div>
                                        <b-pagination
                                            v-show="
                                                all_colors.length > 0 &&
                                                colors_length > itemsPerPage
                                            "
                                            v-model="currentPage"
                                            :total-rows="colors_length"
                                            :per-page="itemsPerPage"
                                            class="imprint_pagination"
                                        ></b-pagination>
                                    </div>
                                </div>

                                <div
                                    id="menu1"
                                    class="tab-pane fade colors-panel"
                                    :class="{
                                        'active show': active_tab == 'thread'
                                    }"
                                >
                                    <div class="pane-body">
                                        <h3>
                                            Embroidery - Standard Thread Colors
                                        </h3>
                                        <p>
                                            Choose from these standard thread
                                            colors for embroidery on apparel,
                                            hats, bags, blankets, towels,
                                            scarves and other accessories. Don’t
                                            see a specific color you’re looking
                                            for? For a $25 thread match fee, we
                                            can match your Pantone color or hex
                                            codes. Hex codes may not be as
                                            accurate. We recommend using a
                                            Pantone color if requiring a
                                            specific thread match. Note: some
                                            colors may not have an exact thread
                                            match.
                                        </p>
                                        <small v-if="all_colors.length == 0"
                                            >No colors found.</small
                                        >
                                        <div class="color-boxes row">
                                            <div
                                                v-for="(
                                                    color, index
                                                ) in all_colors"
                                                class="color-box col-md-2 col-lg-2 col-sm-6"
                                                :key="index"
                                            >
                                                <div
                                                    v-if="color.hex"
                                                    class="color"
                                                    :style="
                                                        'background-color: ' +
                                                        color.hex
                                                    "
                                                >
                                                    <span>{{
                                                        color.name
                                                    }}</span>
                                                </div>
                                                <div
                                                    v-else-if="color.swatches"
                                                    class="color"
                                                    :style="
                                                        'background-image:url(' +
                                                        color.swatches +
                                                        ');background-repeat: no-repeat;background-size: 100% 100%;'
                                                    "
                                                >
                                                    <span>{{
                                                        color.name
                                                    }}</span>
                                                </div>
                                                <p>{{ color.hex }}</p>
                                                <p>{{ color.pms }}</p>
                                                <p>{{ color.name }}</p>
                                            </div>
                                        </div>
                                        <b-pagination
                                            v-show="
                                                all_colors.length > 0 &&
                                                colors_length > itemsPerPage
                                            "
                                            v-model="currentPage"
                                            :total-rows="colors_length"
                                            :per-page="itemsPerPage"
                                            class="imprint_pagination"
                                        ></b-pagination>
                                    </div>
                                </div>

                                <div
                                    id="menu2"
                                    class="tab-pane fade colors-panel"
                                    :class="{
                                        'active show': active_tab == 'vinyl'
                                    }"
                                >
                                    <div class="pane-body">
                                        <h3>
                                            Vinyl - Standard Heat Press Colors
                                        </h3>
                                        <p>
                                            Choose from these standard vinyl
                                            colors for custom logos, names and
                                            numbers. Other limited colors may be
                                            available for a nominal fee.
                                        </p>
                                        <small v-if="all_colors.length == 0"
                                            >No colors found.</small
                                        >
                                        <div class="color-boxes row">
                                            <div
                                                v-for="(
                                                    color, index
                                                ) in all_colors"
                                                class="color-box col-md-2 col-lg-2 col-sm-6"
                                                :key="index"
                                            >
                                                <div
                                                    v-if="color.hex"
                                                    class="color"
                                                    :style="
                                                        'background-color: ' +
                                                        color.hex
                                                    "
                                                >
                                                    <span>{{
                                                        color.name
                                                    }}</span>
                                                </div>
                                                <div
                                                    v-else-if="color.swatches"
                                                    class="color"
                                                    :style="
                                                        'background-image:url(' +
                                                        color.swatches +
                                                        ');background-repeat: no-repeat;background-size: 100% 100%;'
                                                    "
                                                >
                                                    <span>{{
                                                        color.name
                                                    }}</span>
                                                </div>
                                                <p>{{ color.hex }}</p>
                                                <p>{{ color.pms }}</p>
                                                <p>{{ color.name }}</p>
                                            </div>
                                        </div>
                                        <b-pagination
                                            v-show="
                                                all_colors.length > 0 &&
                                                colors_length > itemsPerPage
                                            "
                                            v-model="currentPage"
                                            :total-rows="colors_length"
                                            :per-page="itemsPerPage"
                                            class="imprint_pagination"
                                        ></b-pagination>
                                    </div>
                                </div>

                                <div
                                    id="menu3"
                                    class="tab-pane fade colors-panel"
                                    :class="{
                                        'active show': active_tab == 'fabric'
                                    }"
                                >
                                    <div class="pane-body">
                                        <h3>
                                            Fabric - Standard Heat Press Colors
                                        </h3>
                                        <p>
                                            Choose from these standard fabric
                                            colors for custom logos, names and
                                            numbers. Other limited colors may be
                                            available for a nominal fee.
                                        </p>
                                        <small v-if="all_colors.length == 0"
                                            >No colors found.</small
                                        >
                                        <div class="color-boxes row">
                                            <div
                                                v-for="(
                                                    color, index
                                                ) in all_colors"
                                                class="color-box col-md-2 col-lg-2 col-sm-6"
                                                :key="index"
                                            >
                                                <div
                                                    v-if="color.hex"
                                                    class="color"
                                                    :style="
                                                        'background-color: ' +
                                                        color.hex
                                                    "
                                                >
                                                    <span>{{
                                                        color.name
                                                    }}</span>
                                                </div>
                                                <div
                                                    v-else-if="color.swatches"
                                                    class="color"
                                                    :style="
                                                        'background-image:url(' +
                                                        color.swatches +
                                                        ');background-repeat: no-repeat;background-size: 100% 100%;'
                                                    "
                                                >
                                                    <span>{{
                                                        color.name
                                                    }}</span>
                                                </div>
                                                <p>{{ color.hex }}</p>
                                                <p>{{ color.pms }}</p>
                                                <p>{{ color.name }}</p>
                                            </div>
                                        </div>
                                        <b-pagination
                                            v-show="
                                                all_colors.length > 0 &&
                                                colors_length > itemsPerPage
                                            "
                                            v-model="currentPage"
                                            :total-rows="colors_length"
                                            :per-page="itemsPerPage"
                                            class="imprint_pagination"
                                        ></b-pagination>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>

        <div class="preloader" v-show="isBusy">
            <div class="preloader-body">
                <svg width="40" height="40" viewBox="0 0 40 40">
                    <polygon class="rect" points="0 0 0 40 40 40 40 0" />
                </svg>
            </div>
        </div>
    </div>
</template>
<script>
import ApiService from "@/common/api.service";
import Breadcrumb from "@/components/Breadcrumb";
import commonData from "@/common/common.data";

export default {
    name: "ColorsView",
    data() {
        return {
            isBusy: false,
            breadcrumbs: [],
            active_tab: "ink",
            color_types: ["ink", "thread", "vinyl"],
            colors_shades: [],
            currentPage: 1,
            itemsPerPage: 25,
            colorsConfig: {
                offset: (this.currentPage - 1) * this.itemsPerPage,
                sortBy: "name",
                order: "ASC",
                colors_type: "ink",
                colors_shade: "All",
                vendor: "imprint city",
                limit: 24
            },
            all_colors: [],
            colors_length: null,
            color_shades: []
        };
    },
    components: {
        /* eslint-disable */
        ApiService,
        Breadcrumb
        /* eslint-enable */
    },
    watch: {
        currentPage(newValue) {
            this.colorsConfig.offset = (newValue - 1) * this.itemsPerPage;
            this.getColors();
        }
    },
    computed: {
        pages() {
            if (this.colors_length <= this.itemsPerPage) {
                return [1];
            }
            return [
                ...Array(
                    Math.ceil(this.colors_length / this.itemsPerPage)
                ).keys()
            ].map((e) => e + 1);
        }
    },
    mounted() {
        this.breadcrumbs = [
            { name: `${this.camelCase(this.colorsConfig.colors_type)} Colors` }
        ];
        this.getColors();
        this.getCount();
        this.colors_shades = commonData.colorShades;
    },
    methods: {
        activateTab(el) {
            this.currentPage = 1;
            this.active_tab = el;
            this.colorsConfig.colors_type = el;
            this.colorsConfig.colors_shade = "All";
            this.breadcrumbs = [
                {
                    name: `${this.camelCase(
                        this.colorsConfig.colors_type
                    )} Colors`
                }
            ];
            this.getColors();
            this.getCount();
        },
        filterColorShade(shade) {
            this.currentPage = 1;
            this.colorsConfig.colors_shade = shade;
            this.getColors();
        },
        getColors() {
            var _this = this;
            _this.isBusy = true;
            return new Promise((resolve, reject) => {
                ApiService.post("/get-all-colors", _this.colorsConfig)
                    .then(({ data }) => {
                        _this.all_colors = data.color.rows;
                        _this.colors_length = data.color.count;
                        _this.isBusy = false;
                        resolve(data);
                    })
                    .catch((response) => {
                        _this.isBusy = false;
                        console.log(response);
                        reject(response);
                    });
            });
        },
        getCount() {
            this.color_shades = [];
            return new Promise((resolve, reject) => {
                let params = {
                    type: this.colorsConfig.colors_type,
                    count_type: "color_shades",
                    vendor: this.colorsConfig.vendor
                };
                ApiService.query("/get-colors-count", { params })
                    .then(({ data }) => {
                        // console.log(data);
                        this.color_shades = data.color_shades;
                        resolve(data);
                    })
                    .catch((response) => {
                        console.log(response);
                        reject(response);
                    });
            });
        },
        colorShadeCount(shade) {
            let count = 0;
            let color_shade = this.color_shades.find(
                (colorShade) => colorShade.shade == shade
            );
            if (color_shade) {
                count = color_shade.count;
            }
            return count;
        },
        camelCase(str) {
            return str.charAt(0).toUpperCase() + str.slice(1);
        }
    }
};
</script>
